module.exports = __webpack_public_path__ + "img/women.9c62e016.jpg";